var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import createTwoColumnsImageTextNewScrollAnimation from './animations';
import parser from 'html-react-parser';
import './main.scss';
var TwoColumnsImageTextNew = function (_a) {
    var props = __rest(_a, []);
    var data = props.data;
    var imageSrc = data.image.src;
    var imageAlt = data.image.alt;
    var mainImageRef = useRef(null);
    var scrollContainerRef = useRef(null);
    var mainTitleRef = useRef(null);
    var firstColumnRef = useRef(null);
    var ctaLinkRef = useRef(null);
    useEffect(function () {
        if (!props.noAnimation) {
            createTwoColumnsImageTextNewScrollAnimation({
                scrollContainerRef: scrollContainerRef,
                mainImageRef: mainImageRef,
                ctaLinkRef: ctaLinkRef,
                mainTitleRef: mainTitleRef,
                firstColumnRef: firstColumnRef,
            });
        }
    }, []);
    return (_jsx("div", __assign({ className: "max-full lg:snap-center  snap-start items-center twocolumnsimagetextnew relative", ref: scrollContainerRef }, { children: _jsxs("div", __assign({ className: "twocolumnsimagetextnew-container w-full justify-self-center flex items-center lg:justify-self-auto twocolumnsimagetextnew-orientation-" + (data.orientation ? data.orientation : 'left') + " " + (data.stickyImage ? 'sticky-img-yes' : 'sticky-img-no') + " " + (data.stickyImage && data.paragraph ? 'sticky-img-para-yes' : '') }, { children: [_jsx("div", __assign({ ref: firstColumnRef, className: "two-column-image-text-new-text-container col-1 flex items-center justify-center " + (data.stickyImage ? 'col-1-sticky-img-yes' : 'col-1-sticky-img-no') }, { children: _jsxs("div", __assign({ className: "relative" }, { children: [data.eyebrow && data.eyebrow !== null && (_jsx("span", __assign({ className: " twocolumnsimagetextnew-eyebrow uppercase font-semibold text-silver-medium text-[12px] leading-[1.67]" }, { children: data.eyebrow }), void 0)),
                            _jsxs("h2", __assign({ ref: mainTitleRef, className: "select-none text-silver-medium " + (data.paragraph ? 'md:font-base' : '') }, { children: [data.heading, data.isIncludeFootnote && (_jsx("sup", { children: data.footnote ? data.footnote : 1 }, void 0))] }), void 0),
                            data.paragraph && (_jsx("p", __assign({ className: "twocolumnsimagetextnew-paragraph text-left text-enblue-900 md:pt-4 md:pb-8 mt-4" }, { children: parser(data.paragraph) }), void 0)),
                            _jsx("a", __assign({ href: data.cta.url, target: data.cta.target, className: "button button--animate m-t-30px z-10  inline-block bg-enblue-500 py-2 px-6 text-base " + (data.paragraph ? '' : 'mt-8 md:mt-10 lg:mt-12'), role: "button", tabIndex: 0, ref: ctaLinkRef }, { children: _jsx("span", { children: data.cta.label }, void 0) }), void 0)] }), void 0) }), void 0),
                _jsx("div", __assign({ className: "two-column-image-text-new-image-container col-2 flex items-end w-full " + (data.stickyImage ? 'col-2-sticky-img-yes' : 'col-2-sticky-img-no') }, { children: _jsx("img", { ref: mainImageRef, src: imageSrc, alt: imageAlt, className: "w-full" }, void 0) }), void 0)] }), void 0) }), void 0));
};
export default TwoColumnsImageTextNew;
